// extracted by mini-css-extract-plugin
export default {"searchButtonSvg":"FloatingSearchButton-module__searchButtonSvg___3UN0c"};